import script from "./ContextMenuGroup.vue?vue&type=script&setup=true&lang=js"
export * from "./ContextMenuGroup.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__